var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1744 18.5432L16.8788 21.5638C16.5759 21.8546 16.2106 22.0865 15.8053 22.2455C15.4 22.4044 14.9632 22.487 14.5214 22.4881C14.0797 22.4893 13.6423 22.4091 13.236 22.2523C12.8297 22.0955 12.463 21.8655 12.1582 21.5763L8.86946 18.5766C8.75399 18.6748 8.66392 18.7479 8.57847 18.8252C7.54843 19.7527 6.52533 20.6844 5.49068 21.6076C4.33594 22.627 2.8902 22.8234 1.54608 22.1069C1.11529 21.8995 0.751731 21.5941 0.491307 21.2208C0.230883 20.8475 0.0825968 20.4193 0.0610833 19.9783C0.00796512 18.9067 -0.0590114 17.8184 0.0957242 16.7635C0.416743 14.5534 2.4514 13.0765 5.02186 13.0682C7.49994 13.0682 9.97801 13.0682 12.4584 13.0682H12.8972V10.1771H16.0982V13.0348C16.2737 13.0348 16.4169 13.0556 16.56 13.0577H23.9504C25.8696 13.0577 27.35 13.7722 28.35 15.2657C28.7827 15.9238 29.0072 16.6767 28.9989 17.4424C28.9989 18.2779 29.0105 19.1302 28.9574 19.972C28.865 21.4343 27.2553 22.6291 25.6456 22.5017C24.8229 22.4392 24.0544 22.1054 23.4862 21.5638L20.1744 18.5432Z",
    fill: "url(#paint0_linear_580_860)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9747 23.8387C28.9747 23.9849 28.9931 24.0851 28.9931 24.1854C28.9931 26.2381 28.9931 28.2922 28.9931 30.3477C28.9931 31.4297 28.3534 32 27.1456 32H1.82667C0.925969 32 0.313954 31.6386 0.0968619 30.9556C0.040337 30.7755 0.0123439 30.5892 0.0137203 30.402C0.0137203 28.2936 0.0137203 26.1873 0.0137203 24.0831C0.0137203 24.012 0.0275786 23.9431 0.0368165 23.8387C0.168457 23.9013 0.267765 23.9452 0.364763 23.9953C1.43658 24.575 2.69438 24.808 3.93186 24.6562C5.16934 24.5044 6.31306 23.9767 7.17543 23.1598L8.79207 21.6599L9.08769 21.9064C9.63735 22.3973 10.1685 22.907 10.7413 23.3686C11.7852 24.2082 13.136 24.6681 14.5328 24.6596C15.9297 24.6511 17.2735 24.1748 18.3048 23.3227C18.9353 22.7921 19.4989 22.1968 20.1178 21.6098C20.7252 22.1634 21.2725 22.6542 21.7991 23.1368C22.7927 24.0874 24.1598 24.6464 25.6051 24.693C26.6009 24.734 27.59 24.5265 28.4643 24.0935C28.6236 24.0266 28.7784 23.941 28.9747 23.8387Z",
    fill: "url(#paint1_linear_580_860)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5071 0C14.5694 0.0814674 14.6225 0.146224 14.6664 0.208891C15.5186 1.54161 16.3777 2.87226 17.2207 4.21125C17.9944 5.43743 17.8858 6.73673 16.865 7.73523C15.9251 8.65644 14.7472 8.89039 13.4285 8.5123C12.8627 8.32883 12.3651 8.00548 11.9924 7.57897C11.6197 7.15246 11.3867 6.63993 11.32 6.09963C11.2387 5.49611 11.3731 4.88489 11.7033 4.35537C12.5994 2.93491 13.507 1.52282 14.4101 0.106536C14.4397 0.069064 14.4721 0.0334673 14.5071 0Z",
    fill: "url(#paint2_linear_580_860)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_860",
    x1: 14.5,
    y1: 10.1771,
    x2: 14.5,
    y2: 22.5343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_580_860",
    x1: 14.5034,
    y1: 21.6098,
    x2: 14.5034,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_580_860",
    x1: 14.512,
    y1: 0,
    x2: 14.512,
    y2: 8.68532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthIcon);
export default __webpack_public_path__ + "static/media/birthIcon.b8af0d63aae7b002c339c0b51b186af8.svg";
export { ForwardRef as ReactComponent };